"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Param = void 0;
var flApi = require("./flApi");
var Param = (function () {
    function Param(paramDef, data) {
        this.paramValues = [];
        this.bLoaded = false;
        this.fl = flApi.Api.getInstance();
        this.paramDef = paramDef;
        if (data[0] === "emptyParamfl_12345") {
            this.bLoaded = false;
        }
        else {
            this.bLoaded = true;
            this.insertJsonValue(data);
        }
    }
    Param.prototype.loadValues = function () {
        return __awaiter(this, void 0, void 0, function () {
            var paramValues, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, this.fl.getAllDocuments(this.paramDef.eCN, "p=c" + this.paramDef.fCN)];
                    case 1:
                        paramValues = _a.sent();
                        this.loadDataSet(paramValues);
                        return [2];
                    case 2:
                        err_1 = _a.sent();
                        throw err_1;
                    case 3: return [2];
                }
            });
        });
    };
    Param.prototype.unLoadValues = function () {
        try {
            this.bLoaded = false;
            this.paramValues = [];
        }
        catch (err) {
            throw err;
        }
    };
    Param.prototype.isLoaded = function () {
        return this.bLoaded;
    };
    Param.prototype.loadDataSet = function (paramValues) {
        this.paramValues = [];
        this.insertJsonValue(paramValues);
        this.bLoaded = true;
    };
    Param.prototype.get = function (id) {
        if (!this.bLoaded) {
            throw new Error("not loaded");
        }
        return this.paramValues.find(function (p) { return p.id === id; });
    };
    Param.prototype.getAll = function () {
        if (!this.bLoaded) {
            throw new Error("not loaded");
        }
        return this.paramValues;
    };
    Param.prototype.insert = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var dataSrv, tmpDataToSend, newValue, tmpParam, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        if (!this.bLoaded) {
                            throw new Error("not loaded");
                        }
                        dataSrv = void 0;
                        if (data.param !== undefined) {
                            dataSrv = data;
                        }
                        else {
                            dataSrv = { param: data };
                        }
                        tmpDataToSend = {};
                        tmpDataToSend["c" + this.paramDef.fCN] = dataSrv.param;
                        tmpDataToSend["c" + this.paramDef.fCNOnDemand] = dataSrv.ondemand;
                        return [4, this.fl.insertDocuments(this.paramDef.eCN, tmpDataToSend)];
                    case 1:
                        newValue = _a.sent();
                        tmpParam = this.get(newValue[0].id);
                        if (tmpParam === undefined) {
                            this.insertJsonValue(newValue);
                            tmpParam = this.get(newValue[0].id);
                            if (tmpParam === undefined) {
                                console.error("Param inserted is null !!!!");
                                console.error("data inserted: " + JSON.stringify(tmpDataToSend));
                                console.error("data: " + JSON.stringify(data));
                                console.error("newValue: " + JSON.stringify(newValue[0]));
                                throw new Error("Param not locally inserted");
                            }
                        }
                        return [2, tmpParam];
                    case 2:
                        err_2 = _a.sent();
                        console.error(err_2.stack);
                        throw err_2;
                    case 3: return [2];
                }
            });
        });
    };
    Param.prototype.delete = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var idx, delItem, err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        if (!this.bLoaded) {
                            throw new Error("not loaded");
                        }
                        idx = this.paramValues.findIndex(function (p) { return p.id === id; });
                        if (idx === -1) {
                            throw new Error("not existing");
                        }
                        return [4, this.fl.deleteOneDocument(this.paramDef.eCN, id)];
                    case 1:
                        delItem = _a.sent();
                        if (delItem.length !== 1) {
                            throw new Error("internal server error");
                        }
                        return [2];
                    case 2:
                        err_3 = _a.sent();
                        throw err_3;
                    case 3: return [2];
                }
            });
        });
    };
    Param.prototype.update = function (idUpd) {
        return __awaiter(this, void 0, void 0, function () {
            var myVal, err_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        if (!this.bLoaded) {
                            throw new Error("not loaded");
                        }
                        myVal = this.get(idUpd);
                        if (myVal === undefined) {
                            throw new Error("not found");
                        }
                        return [4, this.fl.restApi.updateParamValue(this.paramDef.name, idUpd, myVal.param, myVal.ondemand)];
                    case 1:
                        _a.sent();
                        return [2, myVal];
                    case 2:
                        err_4 = _a.sent();
                        throw err_4;
                    case 3: return [2];
                }
            });
        });
    };
    Param.prototype.loadOnDemandValue = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var myVal, bigParam, err_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        if (!this.bLoaded) {
                            throw new Error("not loaded");
                        }
                        myVal = this.get(id);
                        if (myVal === undefined) {
                            throw new Error("not found");
                        }
                        return [4, this.fl.getOneDocument(this.paramDef.eCN, id)];
                    case 1:
                        bigParam = _a.sent();
                        if (bigParam.length === 0) {
                            throw new Error("not found on server");
                        }
                        myVal.param = bigParam[0]["c" + this.paramDef.fCN];
                        myVal.ondemand = (bigParam[0]["c" + this.paramDef.fCNOnDemand] === undefined) ? null : bigParam[0]["c" + this.paramDef.fCNOnDemand];
                        return [2, myVal];
                    case 2:
                        err_5 = _a.sent();
                        throw err_5;
                    case 3: return [2];
                }
            });
        });
    };
    Param.prototype.notifyMe = function (msg) {
        var _this = this;
        try {
            if (msg.type === "data" && msg.eCN === this.paramDef.eCN && this.bLoaded) {
                msg.data.forEach(function (aParamValueNotif) {
                    switch (msg.operation) {
                        case "i":
                            _this.insertJsonValue(aParamValueNotif);
                            break;
                        case "u":
                            var myValToUpd = _this.get(aParamValueNotif.id);
                            if (myValToUpd === undefined) {
                                _this.insertJsonValue(aParamValueNotif);
                            }
                            else {
                                myValToUpd.param = aParamValueNotif["c" + _this.paramDef.fCN];
                                myValToUpd.ondemand = aParamValueNotif["c" + _this.paramDef.fCNOnDemand];
                            }
                            break;
                        case "d":
                            var idx = _this.paramValues.findIndex(function (p) { return p.id === aParamValueNotif.id; });
                            if (idx > -1) {
                                _this.paramValues.splice(idx, 1);
                            }
                            break;
                    }
                });
            }
        }
        catch (err) {
            console.error(err.stack);
            throw err;
        }
    };
    Param.prototype.insertJsonValue = function (data) {
        var _this = this;
        var dataArr = data instanceof Array ? data : [data];
        dataArr.forEach(function (aData) {
            try {
                var myValToInsert = {};
                myValToInsert.id = aData.id;
                myValToInsert.param = typeof (aData["c" + _this.paramDef.fCN]) === "string" ?
                    JSON.parse(aData["c" + _this.paramDef.fCN]) : aData["c" + _this.paramDef.fCN];
                myValToInsert.ondemand = typeof (aData["c" + _this.paramDef.fCNOnDemand]) === "string" ?
                    JSON.parse(aData["c" + _this.paramDef.fCNOnDemand]) : aData["c" + _this.paramDef.fCNOnDemand];
                _this.paramValues.push(myValToInsert);
            }
            catch (err) {
                console.error(err.stack);
                throw err;
            }
        });
    };
    return Param;
}());
exports.Param = Param;
